import VDataIterator from './VDataIterator';
export { VDataIterator };
export default VDataIterator;
//# sourceMappingURL=index.js.map